import {
  APP_INITIALIZER,
  EnvironmentProviders,
  Provider,
} from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { loadLibraryTranslations } from '@ui';

export function shareOrganizationSettingsTranslationsInitializer(
  translateService: TranslateService,
  httpBackend: HttpBackend,
): () => Promise<void> {
  return () =>
    loadLibraryTranslations(
      translateService,
      httpBackend,
      (lang) => `assets/share-organization-settings/i18n/${lang}.json`,
    );
}

export function provideShareOrganizationSettings(): (
  | Provider
  | EnvironmentProviders
)[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: shareOrganizationSettingsTranslationsInitializer,
      deps: [TranslateService, HttpBackend],
    },
  ];
}
